// extracted by mini-css-extract-plugin
module.exports = {"body":"AddShopPopouts_body__dl_Jy"};